import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

const messages = {
    erreur: "connexion impossible"
}

class Postier{

    getMesures(token:string,client:string,site:string,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){

        axios.get(`api-v0/${client.split(':')[3]}/${site.split(':')[0]}/flowdistribution`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setMesures(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les mesures ne peuvent pas être récupéré"])
            localStorage.clear()
        })

    }

    getEntities(token:string,client:string,site:string,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){

        axios.get(`api-v0/mesures/${client.split(":")[3]}/${site.split(':')[0]}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setMesures(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les entités ne peuvent pas être récupérées"])
            localStorage.clear()
        })

    }

    createCoef(token:string,data:any, setPage: Dispatch<SetStateAction<string>>, setErrors: Dispatch<SetStateAction<string[]>>){
            
            axios.post(`api-v0/createcoef/`,data,{headers:{ Authorization: `Bearer ${token}` }})
                .then(res=>{
                    setErrors((errors: string[]) => [...errors, "Coefficient créé"])
                    setPage('main')
                    location.reload()
            }).catch(err=>{
                setErrors((errors: string[]) => [...errors, "Le coefficient ne peut pas être créé"])
            })
    
    }


}

export const postier = new Postier()